import { Button } from "components/common";
import useAnimationScreen from "hooks/common/useAnimationScreen";
import useLottie from "hooks/common/useLottie";
import { useEffect, useRef } from 'react';

const CoinPurchaseComplete = () => {
  const { animations, hide } = useAnimationScreen();
  const animation = animations.CoinPurchaseComplete;
  const { amount, isFree } = animation.data;
  const { element: popupElem, getStatus: getPopupStatus, play: playPopup } = useLottie({ path: '/imgweb/lottie/coin_pop.json', loop: false });
  const { currentProgress: currentPopupProgress } = getPopupStatus();

  const { element: pulseElem, play: playPulse } = useLottie({ path: '/imgweb/lottie/coin_pulse.json', useAutoplay: false, loop: true });
  const { element: heartElem, play: playHeart } = useLottie({ path: '/imgweb/lottie/heart_spread.json', useAutoplay: false, loop: false });

  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (currentPopupProgress >= 0.99) {
      popupElem.current?.remove();
      playPulse();
    }
  }, [currentPopupProgress, popupElem, playPulse, playHeart]);

  useEffect(() => {
    setTimeout(() => {
      playHeart();
      Device.vibrate(300, 250);
    }, 700);
  }, [playHeart]);

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      if (currentPopupProgress < 0.7) {
        playPopup();
      }
    }, 3000);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="relative h-full w-full">
      <div className="absolute inset-0" ref={heartElem} />
      <div className="absolute bottom-0 z-10 flex w-full flex-col items-center justify-center">
        <div className="h-[80dvw] w-[100dvw]">
          <div ref={popupElem} />
          <div ref={pulseElem} />
        </div>
        <div
          className="typography-title-lg flex w-full justify-center gap-1"
          style={{ opacity: currentPopupProgress >= 0.7 ? 1 : 0 }}
          dangerouslySetInnerHTML={{
            __html: (isFree ? brsc.swipe_promo_free_coin : brsc.coin_charge_noti).replace('$param', amount > 0 ? amount : '').replace('<span>', '<span style="color: #FF4390;">'),
          }}
        />
        <div className="z-10 mb-8 mt-5 w-full px-4" style={{ opacity: currentPopupProgress >= 0.7 ? 1 : 0 }}>
          <Button onClick={() => hide(animation.id)} style={{ text: brsc.confirm, color: 'btn-bg-primary', fontColor: 'btn-txt-primary', borderRadius: 'full' }} />
        </div>
      </div>
    </div>
  );
};

export default CoinPurchaseComplete;